import $ from 'jquery';
import fitVids from 'fitvids';

function loadVimeoThumbnail() {
  $.getJSON(`http://vimeo.com/api/v2/video/${$('[data-vimeo-image]').data('vimeo-image')}.json?callback=?`,
    data => $('[data-vimeo-image]').attr('src', data[0].thumbnail_large));
}

export default class DynamicVideo {
  constructor({ el }) {
    this.$el = $(el);
    this.initializedClass = 'video-initialized';
    this._bindEvents();
    this.timeouts = [];
    this._validate();
  }

  _bindEvents() {
    this.events = [
      $('.home-video-play-button', this.$el).on('click.video', event => this.openVideo(event)),
      $('body').on('keyup.video', event => this.closeVideo(event)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.video'));
  }

  update($el) {
    this.$el = $el;
    this._validate();
  }

  _validate() {
    if ($('.home-video', this.$el).length) {
      this.videoWrapper = $('.home-video-embed-wrapper', this.$el);
      this.video = $('.home-video-embed', this.$el);
      this.detachedVideo = null;
    }

    if ($('[data-vimeo-image]', this.$el).length) {
      loadVimeoThumbnail();
    }
  }

  openVideo() {
    this.videoWrapper.addClass('opening');

    if (this.detachedVideo) {
      this.video.width('');
      this.detachedVideo.appendTo(this.video);
    } else {
      // scope fitVids to this shopify section using the section id, because fitVids will only
      // accept a css selector, not an element.
      fitVids(`#${this.$el.attr('id')}`);
    }

    this.verticallyCenterVideo();

    this.events.push(
      $(window).on('resize.video', () => this.verticallyCenterVideo()),
      this.videoWrapper.on('click.video', () => this.closeVideo()),
    );

    this.timeouts.push(setTimeout(() => this.videoWrapper.addClass('open'),
      20));
  }

  centerVideoText() {
    const videoContent = $('.home-video-content', this.$el);

    const contentWidth = videoContent.outerWidth();
    const contentHeight = videoContent.outerHeight();

    videoContent.css({
      marginTop: -(contentHeight / 2),
      marginLeft: -(contentWidth / 2),
    });
  }

  verticallyCenterVideo() {
    // Reset everything so the calculations are always fresh
    this.video.css({
      marginTop: 0,
      width: '100%',
    });

    const video = this.video.find('.fluid-width-video-wrapper');
    const videoHeight = video.outerHeight();
    const videoRatio = video.width() / videoHeight;
    const windowHeight = window.innerHeight || $(window).height();
    const availableHeight = windowHeight - 60; // for padding

    if (videoHeight > availableHeight) {
      this.video.removeClass('centered').css({
        marginTop: 0,
        width: availableHeight * videoRatio,
      });
    } else {
      this.video.addClass('centered').css({
        marginTop: -(videoHeight / 2),
        width: '100%',
      });
    }
  }

  closeVideo(e) {
    if (!$('.home-video', this.$el).length) { return; }

    if (e && this.videoWrapper.hasClass('open')) {
      if (e.which !== 27) { return; }
    }

    $(window).off('resize.video');
    this.videoWrapper.off('click.video');
    this.videoWrapper.removeClass('open');

    this.events.push(this.videoWrapper.one('transitionend.video', () => {
      if (this.videoWrapper.hasClass('opening')) {
        this.videoWrapper.removeClass('opening');
        this.detachedVideo = this.video.find('.fluid-width-video-wrapper').detach();
      }
    }));
  }

  onSectionUnload() {
    this._unbindEvents();
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }
}
